import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  AcceptInvitationRequest,
  GetInvitationRequest,
  Invitation,
  InvitationWizardData,
} from '../../types/invitation.ts';

export interface InvitationState {
  invitation?: Invitation;
  loading: boolean;
  error: string;
  wizardData: InvitationWizardData;
  acceptSuccess: boolean;
  acceptError: string;
}

const initialState: InvitationState = {
  invitation: undefined,
  loading: false,
  error: '',
  wizardData: {
    fullName: '',
    password: '',
    confirmPassword: '',
    companyName: '',
    industry: '',
    department: '',
    role: '',
    useCase: '',
  },
  acceptSuccess: false,
  acceptError: '',
};

export const invitationReducer = createSlice({
  name: 'invitation',
  initialState,
  reducers: {
    getInvitation: (state: InvitationState, _action: PayloadAction<GetInvitationRequest>) => {
      state.loading = true;
      state.error = '';
    },
    setInvitation: (state: InvitationState, action: PayloadAction<Invitation>) => {
      state.invitation = action.payload;
      state.loading = false;
      state.error = '';
    },
    setInvitationError: (state: InvitationState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateWizardData: (state: InvitationState, action: PayloadAction<Partial<InvitationWizardData>>) => {
      state.wizardData = { ...state.wizardData, ...action.payload };
    },
    resetWizardData: (state: InvitationState) => {
      state.wizardData = initialState.wizardData;
    },
    acceptInvitation: (state: InvitationState, _action: PayloadAction<AcceptInvitationRequest>) => {
      state.loading = true;
      state.acceptError = '';
    },
    setAcceptSuccess: (state: InvitationState, action: PayloadAction<boolean>) => {
      state.acceptSuccess = action.payload;
      state.loading = false;
      state.acceptError = '';
    },
    setAcceptError: (state: InvitationState, action: PayloadAction<string>) => {
      state.acceptError = action.payload;
      state.loading = false;
      state.acceptSuccess = false;
    },
    resetInvitationState: (_state: InvitationState) => {
      return initialState;
    },
  },
});
